import React from "react";
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";
import Cookies from "js-cookie";
import Index from "../components/CapCandidatureDocument";

export default function CapCandidatureDocument() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const naviagte = useNavigate();

  const handleClick = () => {
    if (page === "addcapcandidaturedocument" || page === "updatecapcandidaturedocument") {
      naviagte(`/${Cookies.get("mhet_mst_project")}/candidature-documentlist`);
    }
  };

  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: page === "candidature-documentlist"  ? "bold" : 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
        ":hover":{
          textDecoration: page === "candidature-documentlist" ? "none" : "underline",
          cursor : page === "candidature-documentlist" ? "none" : "pointer"
        }
      }}
      onClick={page === "candidature-documentlist" ? undefined : handleClick}
    >
     CAP Candidature Document {page === "candidature-documentlist" && <MdKeyboardArrowDown size={16} /> }
    </Typography>,
  ];

  if (page === "addcapcandidaturedocument") {
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Add Cap Candidature Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "updatecapcandidaturedocument"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Update Cap Candidature Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs}/>
      <Sidebar />
      <Layout>
        <PageHeading
          title={
            page === "candidature-documentlist"
              ? "CAP Candidature Document Master"
              : page === "addcapcandidaturedocument"
              ? "Add CAP Candidature Document"
              : page === "updatecapcandidaturedocument"
              ? "Update CAP Candidature Document"
              : null
          }
        />
        
        <Index />
      </Layout>
    </>
  );
}
